/**
 * @var service.ready
 * @var service.banners
 */

const PhotosController =  ['$scope', '$http', function($scope, $http) {

    $scope.album = {};
    $scope.service.photo = null;
    $scope.loadPhoto = function ($item) {
        if (typeof $item !== 'undefined') {
            $scope.album.index = $item.index;
            $scope.service.album.slice = $item.slice;
            $scope.service.album.index = $item.index;
            $scope.service.photo = $item;
        }
    };

    $scope.hidePhoto = function () {
        $scope.service.photo = null;
    };

    $scope.photos = {
        like: function (id) {
            $http.get('/photo/like/' + id).then(function (data) {
                $scope.service.photo.liked = (data.data.action === 'like');
                $scope.service.photo.likes = data.data.likes;
            });
        }
    };

    $scope.prevActive = () => {
        return typeof $scope.service.album.photos[$scope.service.album.index - 1] !== "undefined";
    }
    $scope.prevPhoto = () => {
        if ( typeof $scope.service.album.photos[$scope.service.album.index - 1] !== "undefined" ) {
            $scope.service.photo = $scope.service.album.photos[$scope.service.album.index - 1];
            $scope.loadPhoto($scope.service.photo);
        }
    }
    $scope.nextActive = () => {
        return typeof $scope.service.album.photos[$scope.service.album.index + 1] !== "undefined";
    }
    $scope.nextPhoto = () => {
        if ( typeof $scope.service.album.photos[$scope.service.album.index + 1] !== "undefined" ) {
            $scope.service.photo = $scope.service.album.photos[$scope.service.album.index + 1];
            $scope.loadPhoto($scope.service.photo);
        }
    }

    $scope.$watch('service.ready', (ready) => {
        if (ready === true) {

        }
    });

}];

export default PhotosController;
